import { render, staticRenderFns } from "./PosCashRegisterDetails.vue?vue&type=template&id=4c545deb&scoped=true"
import script from "./PosCashRegisterDetails.vue?vue&type=script&lang=js"
export * from "./PosCashRegisterDetails.vue?vue&type=script&lang=js"
import style0 from "./PosCashRegisterDetails.vue?vue&type=style&index=0&id=4c545deb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c545deb",
  null
  
)

export default component.exports